<!-- eslint-disable max-len -->
<template>
  <div class="form-page-detail-body-container container-app-search">
    <div
      v-if="!load_first"
      class="d-flex align-items-center justify-content-center"
      style="height: 400px; width: 100%">
      <div class="lds-ellipsis"><div/><div/><div/><div/></div>
    </div>
    <div
      v-else
      class="table-column dataset-column">
      <v-client-table
        :data="dataColumn"
        :columns="columns"
        :options="table_options"
        class="jTable">
        <div
          slot="beforeFilter"
          class="custom-search">
          <b-form inline>
            <b-button
              class="btn grey btn-import-form"
              @click="openModalColumn">
              <i class="fa fa-plus fa-lg"/> Add Column
            </b-button>
          </b-form>
        </div>

        <div
          slot="is_primary_key"
          slot-scope="props">
          <j-toggle
            v-if="props.row.type === 'varchar'"
            v-model="props.row.is_primary_key"
            :disabled="(primaryHasBeenSet && props.row.name !== datasetDetail.primary_key) || findRecord"
            :class="{ 'disabled-primary' : primaryHasBeenSet && props.row.name !== datasetDetail.primary_key }"
            @input="setPrimary($event, props)"/>
            <!-- <span
            v-if="props.row.is_primary_key"
            class="text-true">TRUE</span>
          <span
            v-else
            class="text-false">FALSE</span> -->
        </div>

        <div
          v-show="props.row.name !== 'created_at' &&
            props.row.name !== 'updated_at' &&
            props.row.name !== 'updated_by' &&
            props.row.name !== 'created_by' &&
          !findRecord"
          slot="action"
          slot-scope="props">
          <img
            :src="require('@/assets/icon/query/edit.svg')"
            class="cursor-pointer m__r--5"
            width="13"
            @click="openDetail(props)">
          <img
            :src="require('@/assets/icon/query/delete.svg')"
            class="cursor-pointer"
            width="13"
            @click="deleteItem(props)">
        </div>
      </v-client-table>
    </div>

    <b-modal
      ref="appAddColumnModal"
      class="mod-form modal-add-record-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">{{ isDetail ? 'UPDATE' : 'CREATE' }} COLUMN</div>
      <b-form-group :class="{'error-input' : $v.column_data.name.$error}">
        <label> Name </label>
        <j-input
          v-model="$v.column_data.name.$model"
          :error-required="$v.column_data.name.$error"
          :max-length="255"
          placeholder="Name"/>
      </b-form-group>
      <b-form-group :class="{'error-input' : $v.column_data.type.$error}">
        <label> Type </label>
        <j-single-select
          v-model="$v.column_data.type.$model"
          :error-required="$v.column_data.type.$error"
          :options="typeOptions"
          placeholder="Type"/>
      </b-form-group>
      <!-- <b-form-group
        v-show="column_data.type === 'text' && (datasetDetail.primary_key === '' || dataColumnEdit.is_primary_key)"
        :class="{'error-input' : $v.column_data.is_primary_key.$error}">
        <label> Is Primary Key </label>
        <j-toggle
          v-model="$v.column_data.is_primary_key.$model"/>
      </b-form-group> -->
      <div class="float-to-right m__t--10">
        <b-button
          class="btn gray m__r--5"
          @click="closeCreateColumn">
          Close
        </b-button>
        <b-button
          class="btn blue"
          @click="createColumnData">
          Save
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-console */
import { required } from 'vuelidate/lib/validators';
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  // eslint-disable-next-line
  name: 'jDatasetColumn',
  components: {
  },
  data() {
    return {
      load_first: false,
      dataColumn: [],
      columns: ['name', 'type', 'is_primary_key', 'action'],
      table_options: {
        headings: {
          name: 'FIELD',
          type: 'TYPE',
          is_primary_key: 'PRIMARY KEY',
          action: '',
        },
        sortIcon: { base: 'fa', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort' },
        sortable: [],
        filterable: true,
        perPage: 100,
      },
      column_data: {
        name: '',
        type: null,
        // is_primary_key: false,
      },
      typeOptions: [
        {
          id: 'varchar',
          text: 'Varchar (255 char)',
        },
        {
          id: 'text',
          text: 'Text (65.535 char)',
        },
        {
          id: 'small_integer',
          text: 'Small Integer (16 byte)',
        },
        {
          id: 'integer',
          text: 'Integer (32 byte)',
        },
        {
          id: 'big_integer',
          text: 'Big Integer (64 byte)',
        },
        {
          id: 'float',
          text: 'Float (64 byte)',
        },
        {
          id: 'decimal',
          text: 'Decimal (128 byte)',
        },
        {
          id: 'boolean',
          text: 'Boolean',
        },
        {
          id: 'timestamp',
          text: 'Timestamp',
        },
      ],
      isDetail: false,
      findRecord: false,
      indexData: 0,
      dataColumnEdit: null,
      datasetDetail: null,
      primaryHasBeenSet: false,
    };
  },
  computed: {
    ...mapState('jStoreJoana', ['dataset_data']),
  },
  watch: {
    // eslint-disable-next-line
    'column_data.name': function (val){
      const regexSymbol = /[^\w\s]/g;
      setTimeout(() => {
        this.column_data.name =
          val.toLowerCase()
            .replace(regexSymbol, '')
            .replace(' ', '_');
      }, 1);
    },
  },
  created() {
    if (this.dataset_data) {
      this.getDetail();
    }
  },
  methods: {
    ...mapMutations('jStoreJoana', ['setDataset']),
    ...mapActions('jStoreJoana', ['getDetailDatasetByGroup', 'addColumnDataset', 'updateColumnDataset', 'deleteColumnDataset', 'countRecordDataset',
      'removePrimaryKey', 'setPrimaryKey']),
    ...mapActions('jStoreNotificationScreen', ['toggleInfo', 'toggleProblem']),

    getDetail() {
      const req = {
        id: this.dataset_data.id,
      };
      this.getDetailDatasetByGroup(req).then((res) => {
        const dataDetail = res.data || null;
        this.datasetDetail = dataDetail;
        this.primaryHasBeenSet = !!dataDetail.primary_key;
        if (dataDetail && dataDetail.column) {
          const columnData = Object.values(dataDetail.column);
          this.dataColumn = columnData.map((e) => { e.is_primary_key = e.name === this.datasetDetail.primary_key; return e; });
        }

        const param = { dataset_id: this.dataset_data.id };
        this.countRecordDataset(param).then((resp) => {
          this.load_first = true;
          this.findRecord = !!(resp.data && resp.data.count > 0);
        });
      });
    },

    openModalColumn() {
      this.isDetail = false;
      this.$refs.appAddColumnModal.show();
    },

    closeCreateColumn() {
      this.column_data.name = '';
      this.column_data.type = null;
      // this.column_data.is_primary_key = false;
      this.dataColumnEdit = null;
      this.$refs.appAddColumnModal.hide();
      setTimeout(() => {
        this.$v.column_data.$reset();
      }, 500);
    },

    createColumnData() {
      this.$v.column_data.$touch();
      if (!this.$v.column_data.$invalid) {
        const data = {
          dataset_id: this.dataset_data.id,
          name: this.column_data.name,
          type: this.column_data.type,
          // is_primary_key: this.column_data.type === 'text' && this.column_data.is_primary_key,
        };
        const name = this.dataColumnEdit ? this.dataColumnEdit.name : null;

        const action = this.isDetail ? 'updateColumnDataset' : 'addColumnDataset';
        this[action]({ data, name }).then((res) => {
          if (!res.error) {
            this.getDetail();
            this.closeCreateColumn();
          }
        });
      }
    },

    openDetail(data) {
      this.dataColumnEdit = data.row;
      this.isDetail = true;
      this.column_data.name = data.row.name;
      this.column_data.type = data.row.type;
      // this.column_data.is_primary_key = data.row.is_primary_key;
      this.$refs.appAddColumnModal.show();
    },

    deleteItem(data) {
      this.$swal({
        title: 'Are you sure to delete this column ?',
        text: '',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then(async (result) => {
        if (result.value) {
          const param = {
            id: this.dataset_data.id,
            column_name: data.row.name,
          };
          this.deleteColumnDataset(param).then((res) => {
            if (!res.error) {
              this.getDetail();
              this.closeCreateColumn();
            }
          });
        }
      });
    },

    setPrimary(val, data) {
      const param = {
        dataset_id: this.dataset_data.id,
        name: data.row.name,
      };
      const action = val ? 'setPrimaryKey' : 'removePrimaryKey';
      this[action](param).then(() => {
        this.getDetail();
      });
    },
  },
  validations() {
    return {
      column_data: {
        name: { required },
        type: { required },
        // is_primary_key: { },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
  .form-page-detail-body-container {
    // background-color: #ffffff;
    overflow: auto;
    margin: 1px;
    // height: 100%;
  }

  .table-column .jTable {
    width: 95%;
    margin-left: 15px;
  }

  .text-true {
    color: #1a85e4;
    font-weight: bold;
  }

  .text-false {
    color: #ff5a5a;
    font-weight: bold;
  }

  .modal-add-record-data .modal-dialog {
    max-width: 800px !important;
  }

  .disabled-primary {
    opacity: 0.5;
  }
</style>



// WEBPACK FOOTER //
// src/views/joanadb/dataset/jDatasetColumn.vue